<template>
  <div class="item">
    <div class="post-block-style post-float-half clearfix">
      <div class="post-thumb" v-if="article.featured_img">
        <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
          <img class="img-responsive" :src="article.featured_img" />
        </router-link>
      </div>
      <a class="post-cat" href="#" v-if="article.featured_img">
        {{ getCategory(websiteCategory, $route.params.categoryValue).name }}
      </a>
      <div class="post-content">
        <h2 class="post-title">
          <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
            {{ article.title }}
          </router-link>
        </h2>
        <div class="post-meta">
          <span class="post-date">{{ article.date }}</span>
        </div>
        <p>{{ article.short_description }}</p>
      </div>
    </div>
    <div class="gap-30"></div>
  </div>
</template>

<script>
  import { categories } from 'itrnews-vuejs-api';
  import website from '../../mixins/website';

  export default {
    name: 'ArticlePreview',
    mixins: [website, categories],
    props: {
      article: { type: Object, required: true },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/ArticlePreview.vue